import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChartDataCounts {
  withData: number;
  withoutData: number;
}

interface WidgetLayoutState {
  chartDataCounts: ChartDataCounts;
}

const initialState: WidgetLayoutState = {
  chartDataCounts: {
    withData: 0,
    withoutData: 0,
  },
};

const widgetLayoutSlice = createSlice({
  name: 'widgetLayout',
  initialState,
  reducers: {
    setChartDataCounts(state, action: PayloadAction<ChartDataCounts>) {
      state.chartDataCounts = action.payload;
    },
  },
});

export const calculateAndSetChartDataCounts = (sortedData: any[]) => (dispatch: any) => {
  if (!Array.isArray(sortedData)) {
    dispatch(setChartDataCounts({ withData: 0, withoutData: 0 }));
    return;
  }
  const counts = sortedData.reduce(
    (acc, d) => {
      if (Array.isArray(d.dataPoints) && d.dataPoints.length > 0) {
        acc.withData += 1;
      } else {
        acc.withoutData += 1;
      }
      return acc;
    },
    { withData: 0, withoutData: 0 },
  );
  dispatch(setChartDataCounts(counts));
};

export const { setChartDataCounts } = widgetLayoutSlice.actions;

export default widgetLayoutSlice.reducer;
